import { useState } from 'react';

export function useMeetingMenuAction() {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return {
    isEditModalOpen,
    isDeleteModalOpen,
    handleOpenEditModal: () => setIsEditModalOpen(true),
    handleCloseEditModal: () => setIsEditModalOpen(false),
    handleOpenDeleteModal: () => setIsDeleteModalOpen(true),
    handleCloseDeleteModal: () => setIsDeleteModalOpen(false),
  };
}
